import React, { useEffect, useState } from "react";
import { useAppSelector } from "@/hooks/hook";
import { GET, POST } from "@/services/api";
import { API_ROUTES } from "@/services/environment";
import DashboardHeader from "@/components/DashboardHeader";
import { Link } from "react-router-dom";
import { Cocktail } from "@/interfaces/Cocktail";
import { FiEdit2 } from "react-icons/fi";
import ToggleInput from "@/components/toggle/Toggle";

const CocktailsPage = () => {
  const { cocktail, toggleCocktailApi } = API_ROUTES;
  const { refreshToken } = useAppSelector((store) => store.user);
  const { business_id } = useAppSelector((store) => store.user);
  const [searchQuery, setSearchQuery] = useState("");
  const [cocktailList, setCocktailList] = useState<Cocktail[]>([]);
  useEffect(() => {
    (async () => {
      // list of all coctails avaialble
      try {
        const result = await GET(`${cocktail}/${business_id}`, refreshToken);
        setCocktailList(result.data);
      } catch (err) {
        console.log(err);
        // setCustomError('discount', JSON.stringify( err));
      }
    })();
  }, []);
  // toggle cocktail status
  const toggleCocktail = async (cocktailId: string, status: string) => {
    setCocktailList(
      cocktailList.map((item: any) => {
        if (item.id === cocktailId) {
          item.status = status;
        }
        return item;
      })
    );
    const result = await POST(
      `${toggleCocktailApi}/${cocktailId}`,
      {
        status,
      },
      refreshToken
    );
  };
  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(e.target.value);
  };
  const filteredCocktails = Array.isArray(cocktailList)
  ? cocktailList.filter((item) => {
      // in order to search by company and admin name using search query
      const name = item.name.toLowerCase();
      const itemName = item.name.toLowerCase();
      const search = searchQuery.toLowerCase();
      return name.includes(search) || itemName.includes(search);
    })
  : [];
  return (
    <div>
      <div className="">
        <DashboardHeader width="w-full" title="Cocktails">
          <div className="flex items-center gap-3 flex-wrap md:flex-nowrap mt-2 md:mt-0 ">
            <input
              type="text"
              placeholder="Search Cocktail Name"
              onChange={handleSearch}
              className="w-full md:min-w-64 px-4 py-3  rounded-full    focus:outline-none  focus:ring-1 focus:ring-primary-red text-gray-600"
              name=""
              id=""
            />
            <Link
              to="/cocktails/new"
              className="bg-black text-white  rounded-full py-2 px-6 min-w-36"
            >
              {" "}
              <span className="text-lg">+</span> Add New
            </Link>
          </div>
        </DashboardHeader>
        {/* Cocktails List */}
        <div className="grid lg:grid-cols-3 gap-4 md:grid-cols-2 grid=col-1 ">
          {filteredCocktails.length > 0 &&
            filteredCocktails.map((cock: Cocktail) => {
              return (
                <div key={cock.id}>
                  <div className="bg-white px-4 pt-4 pb-1 rounded-xl flex items-center gap-2 max-w-[380px]">
                    <div className="w-4/12">
                      <img
                        src={cock.image}
                        alt={cock.name}
                        className="w-20 h-20  rounded-full"
                      />
                    </div>
                    <div className="w-8/12">
                      <p>{cock.name}</p>
                      <p className="text-sm text-gray-500">Type: {cock.type}</p>
                      <div className="flex justify-end items-center min-w-40 gap-2">
                        <Link to={`/cocktails/${cock.id}`} className="cursor-pointer flex gap-2 bg-p-gray rounded-full px-4 py-1 items-center text-xs">
                          <FiEdit2 size={12} />
                          Edit
                        </Link>
                        <ToggleInput
                          onChange={() =>
                            toggleCocktail(
                              cock.id,
                              cock?.status == "active"
                                ? "unavailable"
                                : "active"
                            )
                          }
                          checked={cock.status == "active"}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
        </div>
      </div>
    </div>
  );
};

export default CocktailsPage;
